import { render } from "./OraDetail.vue?vue&type=template&id=1e9418b7&scoped=true"
import script from "./OraDetail.vue?vue&type=script&lang=js"
export * from "./OraDetail.vue?vue&type=script&lang=js"

import "./OraDetail.vue?vue&type=style&index=0&id=1e9418b7&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9418b7"]])

export default __exports__